<template>
    <CModal
      :color="color"
      size="sm"
      :show.sync="showModal"
    >
    <template #header>
      <CRow style="width: 100%; height: 5px;">
        <CCol md="9">{{title}}</CCol>
        <CCol md="3"></CCol>
      </CRow>
      <CButtonClose @click="showModal = false"/>
    </template>
      <CRow>
        <CCol md="12">
          <CInput
            type="date"
            label="Nueva fecha:"
            :lazy="false"
            :value.sync="date"
            name="date"
            id="date"
          />
        </CCol>
      </CRow>
      <template #footer>
        <CButton @click="closeModal" color="secondary">Cancelar</CButton>
        <CButton @click="changeDate" :color="color">Guardar</CButton>
      </template>
    </CModal>
</template>

<script>
import store from '../../store';
import ws from '../../services/freelancers';

export default {
  name: 'ChangeVisitDateModal',
  data () {
    return {
      showModal: false,
      title: 'Fecha de Visita',
      color: 'info',
      submitted: false,
      visit: false,
      date: ''
    }
  },
  methods: {
    async showVisitModal (visit) {
      this.visit = visit;
      this.date = visit && visit.date ? String(visit.date).substring(0, 10) : '';

      this.loading();

      this.showModal = true;
      this.color = 'info';
      this.title = 'Fecha de Visita';
      this.submitted = false;

      this.loaded();
    },
    async changeDate () {
      if(!this.date){
        this.showToast('error', 'Debe seleccionar una fecha válida.');
        return;
      }

      this.loading();

      let response = await ws.changeVisitDate({id: this.visit.id, date: this.date});

      this.closeModal();

      if(response.type == 'success'){
        this.showToast('success', 'La fecha de la visita fue actualizada correctamente.');
        this.$emit('refresh');
      }
      else{
        this.showToast('error', response.message);
      }

      this.loaded();
    },
    closeModal () {
      this.showModal = false;
      this.submitted = false;
    },
    showToast(type, message){
      store.commit('toast', {color: type, message: message});
    },
    loading(){
      store.commit('loading');
    },
    loaded(){
      store.commit('loaded');
    }
  },
}
</script>

<style>
</style>
